/* Mobile product gallery: size the carousel to the photo being shown instead of the tallest one.
   The slider itself keeps its full height (resizing a scroll-snap container mid-swipe makes it re-snap).
   Instead it sits in a clipping "viewport" whose height follows the swipe frame by frame, blending
   between the two photos in view, and the slider is shifted so the photos stay vertically centered. */
(function () {
  const MOBILE = window.matchMedia('(max-width: 749px)');

  function setup(list) {
    if (list.dataset.adaptiveHeight) return;
    list.dataset.adaptiveHeight = 'true';

    const viewport = document.createElement('div');
    viewport.className = 'product__media-viewport';
    list.parentNode.insertBefore(viewport, list);
    viewport.appendChild(list);

    let frame = null;

    const slides = () => Array.from(list.children).filter((li) => li.offsetParent !== null);

    function reset() {
      viewport.style.height = '';
      list.style.transform = '';
    }

    function update() {
      frame = null;
      if (!MOBILE.matches) return reset();
      const items = slides();
      if (items.length < 2) return reset();

      const step = items[1].offsetLeft - items[0].offsetLeft || list.clientWidth;
      const position = Math.min(Math.max(list.scrollLeft / step, 0), items.length - 1);
      const index = Math.floor(position);
      const next = Math.min(index + 1, items.length - 1);
      const blend = position - index;
      const height = items[index].offsetHeight + (items[next].offsetHeight - items[index].offsetHeight) * blend;

      viewport.style.height = height + 'px';
      list.style.transform = 'translateY(' + -(list.offsetHeight - height) / 2 + 'px)';
    }

    function schedule() {
      if (frame === null) frame = requestAnimationFrame(update);
    }

    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    MOBILE.addEventListener('change', schedule);
    // Photos load lazily, so re-measure when one finishes loading
    list.querySelectorAll('img').forEach((img) => img.addEventListener('load', schedule));
    update();
  }

  function init() {
    document.querySelectorAll('.product__media-list.slider--mobile').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Variant changes and quick add can re-render the gallery
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      init();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
